export default __webpack_public_path__ + "static/media/sticker-m.eceaa2b2.png";